import { Type } from '@sinclair/typebox';
export const PoolAthSchema = Type.Object({
    marketCap: Type.String(),
    price: Type.String(),
});
//# sourceMappingURL=pool-ath.js.map